import { Injectable, OnDestroy } from '@angular/core';
import { Observable, merge, fromEvent, Subject, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class InactivityService implements OnDestroy {

    private _subscriptions: Subscription = new Subscription();

    timeOutRef;
    events: Observable<any>;
    inactivityTimeout = 10;
    timeoutEvent: Subject<any> = new Subject();

    constructor() {
        this.generateEvensts();
    }

    generateEvensts() {
        this.events = merge(
            fromEvent(window, 'mousemove'),
            fromEvent(window, 'resize'),
            fromEvent(window, 'keydown'),
            fromEvent(window, 'touchmove'),
            fromEvent(window, 'wheel'),
            fromEvent(window, 'scroll')
        );
    }

    resetTimer() {
        if (this.timeOutRef) {
            clearTimeout(this.timeOutRef);
        }
        this.timeOutRef = setTimeout(() => this.timeoutEvent.next(true), this.inactivityTimeout * 1000);
    }

    startTimer(inactivityTimeout = 10) {
        this.inactivityTimeout = inactivityTimeout;
        this.resetTimer();

        this._subscriptions.add(
            this.events.pipe(
                throttleTime(1000)
            )
                .subscribe((e) => {
                    this.resetTimer();
                })
        );
    }

    clearResources() {
        if (this.timeOutRef) {
            clearTimeout(this.timeOutRef);
        }
        /* 
        Unsubscribe existing activity listeners (mousemove/keydown/etc).
        If we don't create a new Subscription here, future startTimer() calls will
        fail to attach activity listeners, so the timer won't reset on user actions
        and the user will be logged out even while active.
        */
        this._subscriptions.unsubscribe();
        this._subscriptions = new Subscription();
    }


    ngOnDestroy() {
        this._subscriptions.unsubscribe();
    }
}
